import {
  instance as axios,
  instanceDownloadFile as axiosDF,
  instanceUploadFile as axiosUF
} from "../../configs/axios";

export default {
  getListItemTakes: (options = { params: [] }) => axios.post(`/ItemTake/GetListItemTakes`, options),
  getItemTakeDetail: (itemTakeId) => axios.get(`/ItemTake/GetItemTakeDetail/?token=${itemTakeId}`),
  getDateTimeNow: () => axios.get(`/ItemTake/DateTimeNow`),
  getFileItemTake: (itemTakeId) => axiosDF.get(`/ItemTake/GetFileItemTake/?token=${itemTakeId}`),
  getListItemTakeUpload: (token) => axios.get(`/ItemTake/GetListItemTakeUpload/?token=${token}`),
  getFileItemTakeUploadResult: (options = { param: {} }) =>
    axiosDF.post(`/ItemTake/GetFileItemTakeUploadResult`, options),
  uploadItemTake: (options = { params: [] }) => axios.post(`/ItemTake/UploadItemTake`, options),
  uploadItemResultExcel: (options = { params: {} }) =>
    axiosUF.post(`/ItemTake/UploadItemResultExcel`, options),
};
